import React, { useEffect, useState } from "react";
import StatsCard from "../components/StatsCard";
import { getSeekerStats } from "../data/seekersService";

type SeekerStatsShape = {
  total: number;
  new: number;
  active: number;
  inactive: number;
  onboarding: {
    completed: number;
    consultationScheduled: number;
    experienceCompleted: number;
    basicInfoCompleted: number;
    inProgress: number;
  };
};

export default function SeekerStats() {
  const [stats, setStats] = useState<SeekerStatsShape | null>(null);

  useEffect(() => {
    let mounted = true;

    (async () => {
      try {
        const result = await getSeekerStats();
        if (mounted) setStats(result);
      } catch (err) {
        console.warn("Failed to load seeker stats", err);
        if (mounted) setStats(null);
      }
    })();

    return () => {
      mounted = false;
    };
  }, []);

  return (
    <div className="grid grid-cols-1 gap-4 md:grid-cols-2 xl:grid-cols-4">
      <StatsCard
        label="Total Seekers"
        value={stats ? stats.total : "—"}
        icon="/total_guides.svg"
        variant="brand"
      />
      <StatsCard
        label="New (14d)"
        value={stats ? stats.new : "—"}
        icon="/joindate.svg"
        variant="brand"
      />
      <StatsCard
        label="Active"
        value={stats ? stats.active : "—"}
        icon="/active_guides.svg"
        variant="brand"
      />
      <StatsCard
        label="Inactive"
        value={stats ? stats.inactive : "—"}
        icon="/suspend.svg"
        variant="brand"
      />
    </div>
  );
}
